import { render, staticRenderFns } from "./waybill.vue?vue&type=template&id=36fd8033&scoped=true"
import script from "./waybill.vue?vue&type=script&lang=js"
export * from "./waybill.vue?vue&type=script&lang=js"
import style0 from "./waybill.vue?vue&type=style&index=0&id=36fd8033&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fd8033",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fd8033')) {
      api.createRecord('36fd8033', component.options)
    } else {
      api.reload('36fd8033', component.options)
    }
    module.hot.accept("./waybill.vue?vue&type=template&id=36fd8033&scoped=true", function () {
      api.rerender('36fd8033', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/waybill/waybill.vue"
export default component.exports